/* src/app/common/mpos-forms/components/custom-dual-listbox/custom-listbox.component.css */
div.record-picker {
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid #ddd;
  position: relative;
  cursor: pointer;
  font-family: sans-serif;
}
div.record-picker::-webkit-scrollbar {
  width: 12px;
}
div.record-picker::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
div.record-picker {
  scrollbar-base-color: indigo;
  scrollbar-3dlight-color: indigo;
  scrollbar-highlight-color: indigo;
  scrollbar-track-color: #eee;
  scrollbar-arrow-color: gray;
  scrollbar-shadow-color: gray;
  scrollbar-dark-shadow-color: gray;
}
div.record-picker::-webkit-scrollbar-track {
  background: #eee;
  box-shadow: 0px 0px 3px #dfdfdf inset;
}
div.record-picker::-webkit-scrollbar-thumb {
  background: indigo;
  border: thin solid gray;
}
div.record-picker::-webkit-scrollbar-thumb:hover {
  background: purple;
}
.record-picker ul {
  margin: 0;
  padding: 0 0 1px 0;
}
.record-picker li {
  border-top: thin solid #ddd;
  border-bottom: 1px solid #ddd;
  display: block;
  padding: 2px 2px 2px 10px;
  margin-bottom: -1px;
  font-size: 0.85em;
  cursor: pointer;
  white-space: nowrap;
  min-height: 16px;
  text-align: left;
}
.record-picker li:hover {
  background-color: #f5f5f5;
}
.record-picker li.selected {
  background-color: thistle;
}
.record-picker li.selected:hover {
  background-color: plum;
}
.record-picker li.disabled {
  opacity: 0.5;
  cursor: default;
}
.record-picker li:first-child {
  border-top: none;
}
.record-picker li:last-child {
  border-bottom: none;
}
.record-picker label {
  cursor: pointer;
  font-weight: inherit;
  font-size: 14px;
  padding: 4px;
  margin-bottom: -1px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.record-picker ul.over {
  background-color: lightgray;
}
.dual-list {
  display: flex;
  flex-direction: row;
  align-content: flex-start;
  justify-content: space-evenly;
}
.dual-list .listbox {
  width: 35%;
  margin: 0px;
  flex-grow: 2;
}
.buttonbox {
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.btn-block {
  display: block;
  width: 70px;
  margin: 4px;
}
button {
  color: white;
  font-size: 18px;
  background: indigo;
  padding: 5px 10px;
  border: solid black 1px;
  text-decoration: none;
  cursor: pointer;
}
button:hover {
  background: purple;
  text-decoration: none;
}
button:disabled {
  background: rgba(75, 0, 130, 0.5);
  cursor: default;
}
p {
  font-family: sans-serif;
  font-weight: 600;
  margin-bottom: 4px;
}
/*# sourceMappingURL=data:application/json;base64,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 */
